import React from "react"
import Select from "react-select"
import * as styles from "./BlogIntro.module.scss"
import Section from "@components/structure/Section/Section"

const selectStyles = {
  control: (styles) => ({ ...styles, border: "none", outline: "none", boxShadow: "none" }),
  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: "8px 0px",
    color: "#ff852e",
    ":hover": {
      color: "#ff852e",
    },
  }),
}

const BlogIntro = (props) => (
  <Section inner className={styles.BlogIntro}>
    <div className={styles.intro}>
      <h1>{props.title}</h1>
      <p>{props.description}</p>
    </div>
    <div>
      <div className={styles.sort}>
        <label>Sort by</label>
        <Select
          styles={selectStyles}
          name="sortBy"
          onChange={props.handleSort}
          options={[
            { value: '{ "orderBy":"publishedDate", "order":"DESC"}', label: "Latest" },
            { value: '{ "orderBy":"publishedDate", "order":"ASC"}', label: "Oldest" },
          ]}
          defaultValue={{ value: '{ "orderBy":"publishedDate", "order":"DESC"}', label: "Latest" }}
          isSearchable={false}
        />
      </div>
    </div>
  </Section>
)

export default BlogIntro
